import type { CustomerSupportHistoryItem } from '../../hooks/useCustomerSupportHistoryItems'

type CustomerSupportHistoryListProps = {
  sectionTitle: string
  loadingLabel: string
  emptyLabel: string
  loading: boolean
  items: CustomerSupportHistoryItem[]
}

export const CustomerSupportHistoryList = ({
  sectionTitle,
  loadingLabel,
  emptyLabel,
  loading,
  items,
}: CustomerSupportHistoryListProps) => (
  <section className="ca-card-shell ca-theme-transition rounded-3xl p-5">
    <h2 className="text-sm font-semibold uppercase tracking-[0.16em] text-(--color-text-muted)">{sectionTitle}</h2>

    {loading ? (
      <p className="ca-theme-transition mt-3 rounded-xl border border-(--color-border-default) bg-(--color-bg-surface-muted) px-3 py-2 text-sm text-(--color-text-secondary)">
        {loadingLabel}
      </p>
    ) : null}

    {!loading && items.length === 0 ? (
      <p className="ca-theme-transition mt-3 rounded-xl border border-(--color-border-default) bg-(--color-bg-surface-muted) px-3 py-2 text-sm text-(--color-text-secondary)">
        {emptyLabel}
      </p>
    ) : null}

    {!loading && items.length > 0 ? (
      <ul className="mt-3 space-y-2">
        {items.map((item) => (
          <li
            key={item.id}
            className="ca-theme-transition rounded-xl border border-(--color-border-default) bg-(--color-bg-surface-muted) px-3 py-3"
          >
            <div className="flex flex-wrap items-center justify-between gap-2">
              <p className="font-semibold text-(--color-text-primary)">{item.subject}</p>
              <span
                className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold ${item.statusBadgeClasses}`}
              >
                {item.statusLabel}
              </span>
            </div>
            <p className="mt-1 text-sm text-(--color-text-secondary)">{item.message}</p>
            <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-(--color-text-muted)">
              <span>ID: {item.id}</span>
              <span>{item.openedAtLabel}</span>
              {item.orderLabel ? <span>{item.orderLabel}</span> : null}
              {item.closedAtLabel ? <span>{item.closedAtLabel}</span> : null}
            </div>
          </li>
        ))}
      </ul>
    ) : null}
  </section>
)
